import React, { useState } from 'react';
import { Modal, Calendar, Form, Checkbox, DatePicker, message } from 'antd';
import { useMutation } from '@apollo/client';
import { ADD_HOLIDAY } from '../editFranchise/requests';
import moment from 'moment-timezone';

interface HolidayCalendarProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  refetchLocations: () => void;
  locationId: string | undefined;
  holidays?: any[];
  setHolidays?: (holidays: any[]) => void;
}

const HolidayCalendar: React.FC<HolidayCalendarProps> = ({ visible, setVisible, refetchLocations, locationId, holidays, setHolidays }) => {
  const [selectedDate, setSelectedDate] = useState<moment.Moment | null>(null);
  const [repeat, setRepeat] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [openTime, setOpenTime] = useState<moment.Moment | null>(null);
  const [closeTime, setCloseTime] = useState<moment.Moment | null>(null);

  const [addHoliday] = useMutation(ADD_HOLIDAY);

  const handleDateSelect = (date: moment.Moment) => {
    setSelectedDate(date);
  };

  const handleRepeatChange = (e: any) => {
    setRepeat(e.target.checked);
  };

  const handleSubmit = async () => {
    if (!selectedDate) {
      message.error('Please select a date for the holiday');
      return;
    }

    try {
      const holiday = {
        date: selectedDate?.toISOString(),
        repeat: repeat,
        isOpen: isOpen,
        hours: isOpen && openTime && closeTime
          ? {
            open: openTime.toISOString(),
            close: closeTime.toISOString(),
          }
          : null,
      };

      await addHoliday({
        variables: {
          id: locationId,
          holiday,
        },
      });

      setHolidays?.([...(holidays || []), holiday]);

      message.success('Asueto agregado correctamente');
      refetchLocations();
      onClose();
    } catch (err: any) {
      message.error(`Error: ${err.message}`);
    }
  };

  const handleIsOpenChange = (e: any) => {
    setIsOpen(e.target.checked);
  };

  const handleOpenTimeChange = (time: moment.Moment | null) => {
    setOpenTime(time);
  };

  const handleCloseTimeChange = (time: moment.Moment | null) => {
    setCloseTime(time);
  };

  const onClose = () => {
    setSelectedDate(null);
    setRepeat(false);
    setVisible(false);
    setIsOpen(false);
    setOpenTime(null);
    setCloseTime(null);
  };

  return (
    <Modal
      title="Agregar Asueto"
      visible={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Agregar Asueto"
      cancelText="Cancelar"
    >
      <Calendar onSelect={handleDateSelect}
        style={{
          width: '90%', // Adjust width
          maxHeight: '400px', // Control the height
          overflowY: 'auto',
        }} />
      {selectedDate && (
        <div style={{ marginTop: 16 }}>
          <Form layout="vertical">
            <Form.Item label="Dia Seleccionado">
              <DatePicker value={selectedDate} disabled />
            </Form.Item>
            <div style={{ display: 'flex',
              alignItems: 'center',
              gap: 8 }}>
              <label style={{ marginRight: 8 }}>¿Repetir Anualmente?</label>
              <Form.Item noStyle>
                <Checkbox checked={repeat} onChange={handleRepeatChange} />
              </Form.Item>
            </div>
            <div style={{ display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginTop: 16 }}>
              <label style={{ marginRight: 8 }}>¿Abrir en este asueto?</label>
              <Form.Item noStyle>
                <Checkbox checked={isOpen} onChange={handleIsOpenChange} />
              </Form.Item>
            </div>

            {isOpen && (
              <div style={{ marginTop: 16,
                display: 'flex',
                gap: 16 }}>
                <Form.Item label="Hora de Apertura">
                  <DatePicker
                    showTime
                    value={openTime}
                    onChange={handleOpenTimeChange}
                    format="HH:mm"
                    picker="time"
                  />
                </Form.Item>
                <Form.Item label="Hora de Cierre">
                  <DatePicker
                    showTime
                    value={closeTime}
                    onChange={handleCloseTimeChange}
                    format="HH:mm"
                    picker="time"
                  />
                </Form.Item>
              </div>
            )}

          </Form>
        </div>
      )}
    </Modal>
  );
};

export default HolidayCalendar;
